module.exports = __webpack_public_path__ + "static/media/主页面[新]_03.de3a9816.jpg";